export const routes = (prefix) => [
    {
        path: `/${prefix}/immunization`,
        name: `${prefix}.immunization.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.immunization.index`,
                PageDescription: "Immunization Listing/Create",
            }
        },
    },
]; 
